import { render, staticRenderFns } from "./WorkflowRename.vue?vue&type=template&id=02c285fc"
import script from "./WorkflowRename.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowRename.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports